module.exports = __webpack_public_path__ + "static/img/authenticator_android.7cffe259.png";